var path = 'app/scripts/modules/core/src/modal/wizard/v2wizardPage.component.html';
var html = "<div class=\"modal-page\"\n     ng-if=\"$ctrl.state.rendered\"\n     waypoint=\"{{$ctrl.key}}\">\n  <div class=\"wizard-subheading sticky-header\">\n    <h4 ng-class=\"{ default: !$ctrl.state.done, current: $ctrl.state.current, done: $ctrl.state.done, dirty: $ctrl.state.dirty }\">{{$ctrl.label}}</h4>\n  </div>\n  <div class=\"wizard-page-body\" ng-transclude></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/modal/wizard/v2wizardPage.component.html
// module id = 892
// module chunks = 0